import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api, formatDate } from "@/lib/api";
import { SiteHeader, SiteFooter } from "@/components/SiteHeader";
import { Cover, Eyebrow } from "@/components/ArticleCard";

export default function ArticlePage() {
  const { slug } = useParams();
  const [a, setA] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    setA(null); setErr(false); window.scrollTo(0, 0);
    api.get(`/articles/${slug}`, { params: { track: true } }).then((r) => setA(r.data)).catch(() => setErr(true));
  }, [slug]);

  return (
    <div className="min-h-screen">
      <SiteHeader />
      <main className="max-w-3xl mx-auto px-4 sm:px-8 py-10 sm:py-14">
        <Link to="/" data-testid="back-home-link" className="inline-flex items-center gap-2 text-sm text-slate-500 hover:text-[#C8102E] mb-8">
          <ArrowLeft size={16} /> Kembali
        </Link>
        {err && <p data-testid="article-not-found" className="text-slate-500">Berita tidak ditemukan.</p>}
        {!a && !err && <p className="text-slate-500">Memuat...</p>}
        {a && (
          <article className="fade-up" data-testid="article-detail">
            <Eyebrow cat={a.category} />
            <h1 data-testid="article-title" className="mt-3 font-serif text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-tight text-slate-950">{a.title}</h1>
            <p className="mt-4 text-xs uppercase tracking-widest text-slate-500">{a.author} · {formatDate(a.created_at)}</p>
            <div className="mt-8 aspect-[16/9] overflow-hidden bg-slate-100"><Cover url={a.image_url} /></div>
            {a.summary && <p className="mt-8 text-lg font-medium leading-relaxed text-slate-800 border-l-4 border-[#C8102E] pl-4">{a.summary}</p>}
            <div data-testid="article-content" className="article-body mt-8 text-base sm:text-lg leading-relaxed text-slate-700">
              {a.content.split(/\n+/).filter(Boolean).map((p, i) => <p key={i}>{p}</p>)}
            </div>
          </article>
        )}
      </main>
      <SiteFooter />
    </div>
  );
}
